export const ERC1155Abi = [{
    inputs: [{
        internalType: 'string',
        name: '_uri',
        type: 'string'
    }, { internalType: 'bytes1', name: '_contractChar', type: 'bytes1' }, {
        internalType: 'string',
        name: '_contractURIString',
        type: 'string'
    }, { internalType: 'address', name: '_contractOwner', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'operator', type: 'address' }, {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
    }],
    name: 'ApprovalForAll',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
    }, {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32'
    }, { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' }],
    name: 'RoleAdminChanged',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
    }, { indexed: true, internalType: 'address', name: 'account', type: 'address' }, {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
    }],
    name: 'RoleGranted',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
    }, { indexed: true, internalType: 'address', name: 'account', type: 'address' }, {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
    }],
    name: 'RoleRevoked',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'from', type: 'address' }, {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { indexed: false, internalType: 'uint256[]', name: 'ids', type: 'uint256[]' }, {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
    }],
    name: 'TransferBatch',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'from', type: 'address' }, {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { indexed: false, internalType: 'uint256', name: 'id', type: 'uint256' }, {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
    }],
    name: 'TransferSingle',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
    }, { indexed: true, internalType: 'uint256', name: 'id', type: 'uint256' }],
    name: 'URI',
    type: 'event'
}, {
    inputs: [],
    name: 'BURNER_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'MINTER_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }, {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
    }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
    }, { internalType: 'uint256[]', name: 'ids', type: 'uint256[]' }],
    name: 'balanceOfBatch',
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'baseUri',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '_owner', type: 'address' }, {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
    }, { internalType: 'uint256', name: '_amount', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'cards',
    outputs: [{
        internalType: 'uint64',
        name: 'costInUnicorns',
        type: 'uint64'
    }, { internalType: 'uint64', name: 'costInRainbows', type: 'uint64' }, {
        internalType: 'uint16',
        name: 'maxMintsPerAddress',
        type: 'uint16'
    }, { internalType: 'uint32', name: 'maxSupply', type: 'uint32' }, {
        internalType: 'uint32',
        name: 'allocation',
        type: 'uint32'
    }, { internalType: 'uint32', name: 'mintTimeStart', type: 'uint32' }, {
        internalType: 'bool',
        name: 'locked',
        type: 'bool'
    }, { internalType: 'address', name: 'subContract', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'contractChar',
    outputs: [{ internalType: 'bytes1', name: '', type: 'bytes1' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'contractURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'contractURIString',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '_address', type: 'address' }, {
        internalType: 'uint256',
        name: '_cardCount',
        type: 'uint256'
    }],
    name: 'getTotalBalance',
    outputs: [{ internalType: 'uint256[][]', name: 'amounts', type: 'uint256[][]' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }, {
        internalType: 'address',
        name: 'account',
        type: 'address'
    }], name: 'grantRole', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }, {
        internalType: 'address',
        name: 'account',
        type: 'address'
    }],
    name: 'hasRole',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{
        internalType: 'uint256[]',
        name: '_cardId',
        type: 'uint256[]'
    }, { internalType: 'uint16[]', name: '_maxSupply', type: 'uint16[]' }, {
        internalType: 'address[]',
        name: '_subContract',
        type: 'address[]'
    }], name: 'initCards', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }, {
        internalType: 'address',
        name: 'operator',
        type: 'address'
    }],
    name: 'isApprovedForAll',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'maxTokenId',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '_to', type: 'address' }, {
        internalType: 'uint256',
        name: '_cardId',
        type: 'uint256'
    }, { internalType: 'uint256', name: '_cardLevel', type: 'uint256' }, {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
    }, {
        internalType: 'bytes1',
        name: '_mintedContractChar',
        type: 'bytes1'
    }, { internalType: 'uint256', name: '_number', type: 'uint256' }, {
        internalType: 'uint256[]',
        name: '_data',
        type: 'uint256[]'
    }], name: 'mint', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [],
    name: 'nftStakingPoolAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'numLevel1Minted',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'rainbowPools',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }, {
        internalType: 'address',
        name: 'account',
        type: 'address'
    }], name: 'renounceRole', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }, {
        internalType: 'address',
        name: 'account',
        type: 'address'
    }], name: 'revokeRole', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'from', type: 'address' }, {
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { internalType: 'uint256[]', name: 'ids', type: 'uint256[]' }, {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
    }, { internalType: 'bytes', name: 'data', type: 'bytes' }],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'from', type: 'address' }, {
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { internalType: 'uint256', name: 'id', type: 'uint256' }, {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
    }, { internalType: 'bytes', name: 'data', type: 'bytes' }],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'operator', type: 'address' }, {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
    }], name: 'setApprovalForAll', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'string', name: '_baseURIString', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '_nftStakingPoolAddress', type: 'address' }],
    name: 'setNftStakingPoolAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'string', name: '_contractURIString', type: 'string' }],
    name: 'setcontractURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'tokenVars',
    outputs: [{ internalType: 'uint128', name: 'cardId', type: 'uint128' }, {
        internalType: 'uint32',
        name: 'level',
        type: 'uint32'
    }, { internalType: 'uint32', name: 'number', type: 'uint32' }, {
        internalType: 'bytes1',
        name: 'mintedContractChar',
        type: 'bytes1'
    }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'unicornPools',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: '_cardId', type: 'uint256' }, {
        internalType: 'address',
        name: '_contractAddress',
        type: 'address'
    }], name: 'updateCardSubContract', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'id', type: 'uint256' }],
    name: 'uri',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}] as const;
